import { RoutesLink } from '@/utility/RouteLinks';
import React, { Fragment, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import ChevronArrow from '../Icons/ChevronArrow';
import DashboardIcon from '../Icons/DashboardIcon';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import useSidebarLinks, { IMenuItem } from '@/hooks/useSidebarLinks';
import { useDispatch } from 'react-redux';
import {
  setActiveSidebarTab,
  setDateFilter,
  setScrollPosition,
  setSideBarOpen,
  setTableView,
  setUpdateFilterStates,
} from '@/redux/features/UserSlice';
import NotificationIcon from '../Icons/NotificationIcon';
import moment from 'moment';
import {
  fallbackPermissionKeys,
  getCurrentFinancialYear,
} from '@/utility/helper';
const Sidebar: React.FC = () => {
  const nonActiveNumber = -1;
  const dispatch = useDispatch();
  const sidebarOpen = useSelector(
    (state: RootState) => state.user?.isSideBarOpen,
  );
  const activeSidebarTab = useSelector(
    (state: RootState) => state?.user?.activeSidebarTab,
  );
  const userDetails = useSelector((state: RootState) => state?.user?.user);
  const scrollPosition = useSelector(
    (state: RootState) => state?.user?.scrollPosition,
  );
  const { groupedMenu } = useSidebarLinks();
  console.log('groupedMenu', groupedMenu);
  const location = useLocation();
  const isRouteActive = (relatedRoutes: string[] = []) => {
    return relatedRoutes.some((route) => {
      if (!route) return false;
      if (route.includes('/:')) {
        const baseRoute = route.split('/:')[0];
        return location.pathname.startsWith(baseRoute);
      }
      return location.pathname === route;
    });
  };

  const toggleSidebarTab = (activeTab: number) => {
    dispatch(setScrollPosition(scrollPosition));
    if (activeSidebarTab === activeTab) {
      dispatch(setActiveSidebarTab(nonActiveNumber));
    } else {
      dispatch(setActiveSidebarTab(activeTab));
    }
  };
  useEffect(() => {
    if (window.innerWidth >= 992) {
      dispatch(setSideBarOpen(true));
    }
  }, [dispatch]);
  useEffect(() => {
    const sidebarScroll = document.getElementById('sideWrapper');
    const handleScroll = () => {
      if (!sidebarScroll) return;
      const scrollTop = sidebarScroll?.scrollTop;
      dispatch(setScrollPosition(scrollTop));
    };
    sidebarScroll?.addEventListener('scroll', handleScroll);
    return () => {
      sidebarScroll?.removeEventListener('scroll', handleScroll);
    };
  }, [dispatch]);
  useEffect(() => {
    const sidebarScroll = document.getElementById('sideWrapper');
    if (sidebarScroll) {
      sidebarScroll.scrollTop = scrollPosition;
    }
  }, [scrollPosition]);

  const resetFilters = (activeSidebar: boolean) => {
    dispatch(
      setUpdateFilterStates({
        currentPage: 1,
        pageSize: 10,
        count: 0,
        totalPages: 0,
        sortByDate: [
          moment(moment().subtract(30, 'days').toDate()).format('YYYY-MM-DD'),
          moment(moment().toDate()).format('YYYY-MM-DD'),
        ],
        year: getCurrentFinancialYear(),
        companyId: '',
        siteId: '',
        dashboardSiteId: '',
        leaveType: '',
        leaveStatus: '',
        department: '',
        designation: '',
        requestType: '',
        stockStatus: '',
        vendorId: '',
        empStatus: 'current',
        customerId: '',
        customerCompanyId: '',
        orderBy: '',
      }),
    );
    dispatch(setTableView('table'));
    dispatch(
      setDateFilter([
        moment().startOf('month').format('YYYY-MM-DD'),
        moment().endOf('month').format('YYYY-MM-DD'),
      ]),
    );
    if (activeSidebar) {
      dispatch(setActiveSidebarTab(nonActiveNumber));
    }
  };
  return (
    <aside className={`sidebar-wrapper ${sidebarOpen ? 'open' : ''}`}>
      <div className="sidebar-content">
        <NavLink to={RoutesLink?.dashboard} className="navbar-brand ">
          <img
            className="main-logo"
            src={'/assets/images/sidebarlogo.png'}
            alt="main-logo"
          />
        </NavLink>
        <div className="sidebar-inner">
          <nav className="aside-nav" id="sideWrapper">
            <ul className="sidebar-vertical mt-3">
              <li>
                <NavLink
                  to={RoutesLink?.dashboard}
                  className="drop-link"
                  onClick={() => resetFilters(true)}
                >
                  <DashboardIcon />
                  <span>Dashboard</span>
                </NavLink>
              </li>
              {Object.entries(groupedMenu).map(
                ([sectionKey, items], sectionIndex) => {
                  let permissionKey =
                    typeof userDetails?.designation?.menuBar == 'string'
                      ? JSON.parse(userDetails?.designation?.menuBar)
                      : userDetails?.designation?.menuBar;
                  if (userDetails?.type === 1) {
                    if (
                      !permissionKey ||
                      !permissionKey.keyNames ||
                      permissionKey.keyNames.length === 0
                    ) {
                      permissionKey = {
                        keyNames: fallbackPermissionKeys,
                      };
                    }
                  }
                  const sectionItems: IMenuItem[] = items.filter(
                    (section: IMenuItem) => {
                      if (
                        permissionKey?.keyNames.includes(
                          section?.permissionKey,
                        ) ||
                        section?.permissionKey === 'show'
                      ) {
                        return {
                          ...items,
                        };
                      }
                    },
                  );
                  // const sectionItems = items;
                  return (
                    <Fragment key={sectionKey}>
                      {sectionItems?.length > 0 &&
                        sectionKey !== 'default' &&
                        sectionKey != 'Site' && (
                          <li key={sectionKey}>
                            <span className="menu-title border-top pt-3">
                              {sectionKey}
                            </span>
                          </li>
                        )}
                      {sectionItems?.map(
                        (menuItem: IMenuItem, itemIndex: number) => {
                          const index = sectionIndex * 10 + itemIndex;
                          const subMenus = menuItem.subMenu || [];
                          const hasSubMenu = subMenus.length > 1;
                          // const isMenuActive = isRouteActive(
                          //   menuItem.relatedRoutes,
                          // );

                          if (hasSubMenu) {
                            return (
                              <Fragment key={`${sectionKey}-${menuItem.label}`}>
                                {menuItem?.isShowBorder && (
                                  <li>
                                    <span className="menu-title border-top"></span>
                                  </li>
                                )}
                                <li>
                                  <a
                                    className={`drop-link btn-menu ${
                                      activeSidebarTab === index ? 'active' : ''
                                    }`}
                                    role="button"
                                    onClick={() => toggleSidebarTab(index)}
                                  >
                                    {menuItem.icon}
                                    <span>{menuItem.label}</span>
                                    <ChevronArrow
                                      activeSidebarTab={activeSidebarTab}
                                      currentActiveTab={index}
                                    />
                                  </a>
                                  <ul
                                    className={`sub-menu ${
                                      activeSidebarTab === index
                                        ? 'menu-open'
                                        : 'menu-close'
                                    }`}
                                  >
                                    {subMenus.map((sub, subIndex) => (
                                      <li key={subIndex}>
                                        <NavLink
                                          to={sub.to}
                                          state={sub.state}
                                          className={`drop-link inner ${
                                            isRouteActive(sub.relatedRoutes)
                                              ? 'active'
                                              : ''
                                          }`}
                                          onClick={() => resetFilters(false)}
                                        >
                                          <span>{sub.label}</span>
                                        </NavLink>
                                      </li>
                                    ))}
                                  </ul>
                                </li>
                              </Fragment>
                            );
                          }
                          return (
                            <li key={`${sectionKey}-${menuItem.label}`}>
                              <NavLink
                                onClick={() => resetFilters(true)}
                                to={
                                  subMenus.length === 1
                                    ? subMenus[0].to
                                    : menuItem.to
                                }
                                className={`drop-link pt-3 pb-3 ${isRouteActive(menuItem.relatedRoutes) ? 'active' : ''}`}
                              >
                                {menuItem.icon}
                                <span>
                                  {subMenus.length === 1
                                    ? subMenus[0].label
                                    : menuItem.label}
                                </span>
                              </NavLink>
                            </li>
                          );
                        },
                      )}
                    </Fragment>
                  );
                },
              )}
              <li className="border-top pt-3">
                <NavLink
                  to={RoutesLink.notification}
                  className="drop-link "
                  role="button"
                  onClick={() => resetFilters(true)}
                >
                  <NotificationIcon />
                  <span>Notifications</span>
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </aside>
  );
};
export default Sidebar;
